import {
    Directive,
    ElementRef,
    inject,
    Renderer2,
    EnvironmentInjector,
    effect,
    input,
    createComponent,
    OnDestroy
} from '@angular/core';
import { SkeletonRectComponent } from './skeleton-rect.component';

@Directive({
    selector: '[novaSkeletonLoader]',
    standalone: true
})
export class SkeletonLoaderDirective implements OnDestroy {
    isLoading = input(true);
    repeat = input(1);
    width = input('100%');
    height = input('20px');
    className = input('');

    private skeletonElements: HTMLElement[] = [];
    private originalChildren: Node[] = [];

    private hostElement = inject(ElementRef<HTMLElement>);
    private renderer = inject(Renderer2);
    private environmentInjector = inject(EnvironmentInjector);

    constructor() {
        effect(() => {
            if (this.isLoading()) {
                this.showSkeletons();
            } else {
                this.hideSkeletons();
            }
        });
    }

    ngOnDestroy(): void {
        this.hideSkeletons();
    }

    private showSkeletons() {
        const host = this.hostElement.nativeElement as Element;

        this.originalChildren = Array.from(host.childNodes);
        this.originalChildren.forEach((node) => {
            if (node instanceof HTMLElement) {
                this.renderer.setStyle(node, 'display', 'none');
            }
        });

        this.skeletonElements = Array.from({ length: this.repeat() }).map(() => {
            const componentRef = createComponent(SkeletonRectComponent, {
                environmentInjector: this.environmentInjector
            });

            Object.assign(componentRef.instance, {
                width: this.width() === 'rand' ? `${Math.floor(Math.random() * 62) + 30}%` : this.width(),
                height: this.height(),
                className: this.className()
            });

            componentRef.changeDetectorRef.detectChanges();

            const element = componentRef.location.nativeElement as HTMLElement;
            this.renderer.appendChild(host, element);
            return element;
        });
    }

    private hideSkeletons() {
        this.skeletonElements.forEach((el) => el.remove());
        this.skeletonElements = [];

        this.originalChildren.forEach((node) => {
            if (node instanceof HTMLElement) {
                this.renderer.removeStyle(node, 'display');
            }
        });
    }
}
